import { type ElementType } from 'react';
import { Lock } from 'lucide-react';
import { Card, CardContent } from '@g17eco/ui-modern/components/ui/card';
import { Button } from '@g17eco/ui-modern/components/ui/button';
import { cn } from '@g17eco/ui-modern/lib/utils';

export interface ActivitySelectionCardProps {
  Icon: ElementType;
  iconBg: string;
  iconColor: string;
  label: string;
  description: string;
  onClick?: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  comingSoon?: boolean;
  actionLabel?: string;
}

export const ActivitySelectionCard = ({
  Icon,
  iconBg,
  iconColor,
  label,
  description,
  onClick,
  isSelected,
  isDisabled,
  comingSoon,
  actionLabel,
}: ActivitySelectionCardProps) => (
  <Card
    className={cn(
      'tw:transition-all tw:h-full',
      isDisabled || comingSoon
        ? 'tw:cursor-not-allowed tw:border-dashed'
        : isSelected
          ? 'tw:border-emerald-500 tw:bg-emerald-50 tw:shadow-md tw:cursor-pointer'
          : 'tw:cursor-pointer tw:hover:shadow-md tw:hover:border-emerald-300'
    )}
    onClick={isDisabled || comingSoon ? undefined : onClick}
  >
    <CardContent className={cn('tw:p-4 tw:flex tw:flex-col tw:gap-2', comingSoon && 'tw:bg-muted')}>
      <div
        className={cn('tw:rounded-full tw:inline-flex tw:items-center tw:justify-center', iconBg, isDisabled || comingSoon && 'tw:bg-white')}
        style={{ width: 44, height: 44 }}
      >
        <Icon className={cn('tw:size-5', iconColor, comingSoon && 'tw:text-muted-foreground')} />
      </div>

      <div className='tw:items-center tw:justify-center tw:gap-2'>
        <div className={cn('tw:text-base tw:font-bold tw:text-[#1a1d1f] tw:leading-snug', comingSoon && 'tw:text-muted-foreground')}>{label}</div>
        {comingSoon && (
          <div className='tw:inline-flex tw:items-center tw:gap-1 tw:bg-yellow-500 tw:text-xs tw:rounded-full tw:px-2 tw:py-0.5'>
            <Lock size={10} />
            Coming Soon
          </div>
        )}
      </div>

      <div className='tw:text-xs tw:text-muted-foreground tw:leading-[1.35]'>{description}</div>

      {actionLabel && !comingSoon && (
        <Button variant='outline' disabled={isDisabled}>
          {actionLabel}
        </Button>
      )}
    </CardContent>
  </Card>
);
